import { HStack, Box } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const LogoListTablet = () => (
  <Box flexDir="column" d={{ base: 'none', tablet: 'flex', desktop: 'none' }}>
    <HStack d="flex" spacing="auto" alignItems="center" px={500} mb={700}>
      <StaticImage
        placeholder="blurred"
        src="../../../assets/images/state_farm_logo_1.png"
        alt="crawford-logo"
        height={24}
        width={175}
      />
      <StaticImage
        height={100}
        placeholder="blurred"
        objectFit="contain"
        src="../../../assets/images/logo_nationWide.png"
        alt="gaf logo"
      />
      <StaticImage
        placeholder="blurred"
        width={123}
        height={35}
        src="../../../assets/images/amfam_logo.png"
        alt="srs logo"
      />
      <StaticImage
        placeholder="blurred"
        width={162}
        height={38}
        src="../../../assets/images/travelers_vector_logo_red.png"
        alt="travelers logo"
      />
    </HStack>
    <HStack
      d="flex"
      spacing={1000}
      alignItems="center"
      px={500}
      justifyContent="center"
    >
      <StaticImage
        placeholder="blurred"
        width={67}
        height={67}
        src="../../../assets/images/shelter-insurance.png"
        alt="owens corning logo"
      />
      <StaticImage
        placeholder="blurred"
        width={134}
        height={59}
        src="../../../assets/images/cincinatti_logo.png"
        alt="bacon roofing supply logo"
      />
    </HStack>
  </Box>
);

export default LogoListTablet;
